import { Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';

import { CostCenterPickerField } from '../../../../../../../../../../components/entity-picker/CostCenterPickerField';
import { PaymentKindPickerField } from '../../../../../../../../../../components/entity-picker/PaymentKindPickerField';
import { TaxGroupPickerField } from '../../../../../../../../../../components/entity-picker/TaxGroupPickerField';
import { ControllerPlus } from '../../../../../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../../../../../form-plus/use-form-context-plus';
import { NumberInput } from '../../../../../../../../locked-inputs';
import { useEntityRightsContext } from '../../../../../../../hooks/use-entity-rights';
import { ServiceContractsFormValue } from '../../../../../types';

export const Billing: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContextPlus<ServiceContractsFormValue>();
  const rights = useEntityRightsContext();

  return (
    <Collapse defaultOpen={true} title={t('COMMON.PAYMENT_AND_TAX')}>
      <Grid container spacing="1rem">
        <Grid item xs={6} sm={6}>
          <ControllerPlus
            control={control}
            name="costCenter"
            render={({ field }) => {
              return (
                <CostCenterPickerField
                  label={t('COMMON.COST_CENTER')}
                  {...field}
                />
              );
            }}
          />
        </Grid>

        <Grid item xs={6} md={6}>
          <ControllerPlus
            name="taxGroup"
            control={control}
            render={({ field }) => {
              return <TaxGroupPickerField {...field} clearable />;
            }}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={6}>
          <ControllerPlus
            control={control}
            name="paymentKind"
            render={({ field }) => {
              return <PaymentKindPickerField {...field} />;
            }}
          />
        </Grid>

        <Grid item xs={6} sm={3} md={2}>
          <ControllerPlus
            control={control}
            name="paymentDeadline"
            render={({ field: paymentDeadline }) => {
              return (
                <NumberInput
                  {...paymentDeadline}
                  disabled={!rights.update}
                  label={t('INPUTS.NET_PAYMENT')}
                  selectOnFocus
                  unit={t('INPUTS.DAY')}
                  truncate
                  defaultValue={14}
                  min={0}
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          <ControllerPlus
            control={control}
            name="skontoDurationDays"
            render={({ field: skontoDurationDays }) => {
              return (
                <NumberInput
                  {...skontoDurationDays}
                  disabled={!rights.update}
                  label={t('INPUTS.DISCOUNT')}
                  selectOnFocus
                  unit={t('COMMON.DAY', { count: skontoDurationDays.value })}
                  truncate
                  defaultValue={0}
                  min={0}
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          <ControllerPlus
            control={control}
            name="skonto"
            render={({ field: skonto }) => {
              return (
                <NumberInput
                  {...skonto}
                  disabled={!rights.update}
                  label={t('INPUTS.DISCOUNT_VALUE')}
                  selectOnFocus
                  unit="%"
                  truncate
                  defaultValue={0}
                  decimals={2}
                  min={0}
                />
              );
            }}
          />
        </Grid>
      </Grid>
    </Collapse>
  );
};
